import { Link } from "react-router";
import { prof_routes } from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Avvvatars from "avvvatars-react";
import { useSelector } from "react-redux";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

const TeacherDashboard = () => {
  const routes = prof_routes;

  const teacher = useSelector((state: any) => state.auth.user);
  const { selectedYear } = useAcademicYear();

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Tableau de bord</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Tableau de bord
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}

          <div className="row">
            <div className="col-xxl-12">
              {/* Profile */}
              <div className="flex-fill">
                <div className="card bg-dark position-relative">
                  <div className="card-body">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <div className="avatar avatar-xxl rounded flex-shrink-0 me-3">
                        <Avvvatars
                          value={`${teacher.firstname?.charAt(0) || ""}${teacher.lastname?.charAt(0) || ""}`}
                          style="character" // ou "character"
                          size={70}
                        />
                      </div>
                      <div className="d-block">
                        <span className="badge bg-transparent-primary text-primary mb-1">
                          Professeur
                        </span>
                        <h3 className="text-truncate text-white mb-1">
                          {teacher.firstname} {teacher.lastname}
                        </h3>
                        <div className="d-flex align-items-center flex-wrap row-gap-2 text-gray-2">
                          <span className="border-end me-2 pe-2">
                            Spécialité : {teacher.speciality}
                          </span>
                          <br />
                          <p>
                            <span>Année : {selectedYear?.label}</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="student-card-bg">
                      <ImageWithBasePath
                        src="assets/img/bg/circle-shape.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/shape-02.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/shape-04.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/blue-polygon.png"
                        alt="Bg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Profile */}
            </div>

            <div className="col-xxl-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">Liens Rapides</h4>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-6 col-md-4 mb-3">
                      <Link
                        to={routes.teacherEDT}
                        className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
                            <i className="ti ti-calendar" />
                          </span>
                        </div>
                        <p className="text-dark">Emploi du Temps</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-3">
                      <Link
                        to={routes.teacherCourse}
                        className="d-block bg-secondary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-secondary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-secondary rounded-circle">
                            <i className="ti ti-license" />
                          </span>
                        </div>
                        <p className="text-dark">Mes Cours</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-3">
                      <Link
                        to={routes.messagePage}
                        className="d-block bg-info-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-info rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-info rounded-circle">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                        <p className="text-dark">Mes messages</p>
                      </Link>
                    </div>
                  </div>
                  {/* </Slider> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherDashboard;
